export type CategorySeed = {
  category: string;
  subCategory: string[];
};

export const CATEGORY_SEED: CategorySeed[] = [
  {
    category: "Food, Drink & Hospitality",
    subCategory: [
      "Restaurants",
      "Hotels & Lodges",
      "Cafés & Coffee Shops",
      "Fast Food & Takeaway",
      "Bars & Lounges",
      "Catering Services",
      "Bakeries & Cake Shops",
      "Butchery & Meat Shop",
      "Grocery & Mini-mart",
      "Fruits & Vegetables Vendor",
      "Water Refill & Purified Water",
      "Street Food / Vibanda",
      "Food Delivery",
    ],
  },
  {
    category: "Retail & Shopping",
    subCategory: [
      "Supermarket / Wholesale",
      "Boutique / Fashion Shop",
      "Shoes Shop",
      "Bags & Accessories",
      "Cosmetics & Beauty Shop",
      "Perfumes & Fragrances",
      "Jewelry & Watches",
      "Baby Shop",
      "Bookshop & Stationery",
      "Toys & Games",
      "Gift Shop",
      "Household Goods",
      "Second-hand (Mitumba)",
      "Online Seller / E-commerce",
    ],
  },
  {
    category: "Electronics, Phones & Computers",
    subCategory: [
      "Phone Shop",
      "Phone Repair",
      "Computer Shop",
      "Computer Repair",
      "Laptop Sales",
      "Accessories (Chargers, Earphones, Cases)",
      "TV & Home Entertainment",
      "CCTV & Security Systems",
      "Networking & WiFi Installation",
      "Solar & Inverters",
      "Printers & Photocopiers Sales/Repair",
    ],
  },
  {
    category: "Home & Building",
    subCategory: [
      "Hardware / Building Materials",
      "Plumbing Services",
      "Electrical Services",
      "Painting Services",
      "Carpentry & Joinery",
      "Welding & Fabrication",
      "Tiles & Fittings",
      "Interior Design",
      "Curtains & Blinds",
      "Furniture Shop",
      "Gypsum & Ceiling",
      "Roofing & Mabati",
      "Glass & Aluminium Works",
      "Borehole / Water Services",
      "Cleaning Services",
      "Pest Control",
      "Movers & Relocation",
    ],
  },
  {
    category: "Real Estate & Property",
    subCategory: [
      "Property Agent / Broker",
      "Property Management",
      "House & Shop Rentals",
      "Land & Plots",
      "AirBnB / Short Stays",
      "Property Valuation",
      "Surveyor",
      "Architect",
      "Quantity Surveyor",
      "Construction Company",
    ],
  },
  {
    category: "Professional Services",
    subCategory: [
      "Accounting & Bookkeeping",
      "Tax Consultant (KRA)",
      "Auditing Firm",
      "Legal Services / Advocate",
      "Notary / Commissioner for Oaths",
      "Insurance Agent",
      "Business Consulting",
      "HR & Recruitment",
      "Translation Services",
      "Research & Data Services",
    ],
  },
  {
    category: "Beauty, Health & Wellness",
    subCategory: [
      "Salon (Ladies)",
      "Barbershop",
      "Spa & Massage",
      "Nail Studio",
      "Makeup Artist",
      "Skincare Clinic",
      "Gym & Fitness Center",
      "Nutritionist / Dietician",
      "Physiotherapy",
      "Counseling & Therapy",
      "Yoga & Wellness Studio",
    ],
  },
  {
    category: "Medical & Pharmacy",
    subCategory: [
      "Pharmacy / Chemist",
      "Clinic",
      "Hospital",
      "Dental Clinic",
      "Optical / Optician",
      "Laboratory & Diagnostics",
      "Maternity / Nursing Home",
      "Home Care & Nursing",
      "Ambulance Services",
      "Medical Equipment Supplier",
    ],
  },
  {
    category: "Automotive & Transport",
    subCategory: [
      "Garage / Mechanic",
      "Car Wash",
      "Tyre Center",
      "Battery Shop",
      "Spare Parts",
      "Panel Beating & Spray Painting",
      "Auto Electrician",
      "Windscreen & Auto Glass",
      "Car Hire / Rental",
      "Driving School",
      "Towing Services",
      "Motorcycle (Boda) Services",
      "Motorbike Spares & Repair",
      "PSV / Shuttle Services",
      "Logistics & Courier",
    ],
  },
  {
    category: "Education & Training",
    subCategory: [
      "Primary School",
      "Secondary School",
      "College / TVET",
      "University Services",
      "Tuition & Home Tuition",
      "Computer Classes",
      "Music School",
      "Beauty School",
      "Exam Printing & Revision Materials",
      "Daycare & Kindergarten",
    ],
  },
  {
    category: "Repairs & Maintenance",
    subCategory: [
      "Appliance Repair",
      "Mobile Repair",
      "Locksmith",
      "Shoe Repair",
      "Upholstery",
      "Tailor & Alterations",
      "Watch Repair",
      "Furniture Repair",
      "Generator Repair",
      "AC Installation & Repair",
    ],
  },
  {
    category: "Events, Media & Creative",
    subCategory: [
      "Event Planning",
      "Event Decor & Tents",
      "Sound System & DJ",
      "MC & Entertainment",
      "Photography",
      "Videography",
      "Graphic Design",
      "Printing Services",
      "Branding & Signage",
      "Screen Printing",
      "Wedding Services",
      "Event Car Hire",
    ],
  },
  {
    category: "Finance & Money Services",
    subCategory: [
      "Bank Branch / Agent",
      "SACCO",
      "Microfinance",
      "Loan Services",
      "M-Pesa Agent",
      "Airtel Money Agent",
      "Forex Bureau",
      "Mobile Money Shop",
      "POS & Payment Services",
    ],
  },
  {
    category: "Telecom & Digital Services",
    subCategory: [
      "Cyber Café",
      "Printing & Photocopy",
      "KRA iTax Services",
      "HELB Services",
      "eCitizen Services",
      "Passport & Visa Support",
      "Internet Provider",
      "Web Design & Development",
      "Digital Marketing",
      "Social Media Management",
    ],
  },
  {
    category: "Agriculture & Livestock",
    subCategory: [
      "Agrovet",
      "Farm Inputs",
      "Animal Feeds",
      "Veterinary Services",
      "Poultry Farming",
      "Dairy Products",
      "Greenhouse & Irrigation",
      "Farm Equipment",
      "Produce Buyer / Aggregator",
      "Beekeeping Products",
    ],
  },
  {
    category: "Industry & Manufacturing",
    subCategory: [
      "Small Manufacturing",
      "Packaging Supplier",
      "Timber Yard",
      "Welding & Fabrication",
      "Water & Ice Supplier",
      "Gas Refill (LPG)",
      "Chemicals & Detergents Supplier",
    ],
  },
  {
    category: "Religious & Community",
    subCategory: [
      "Church",
      "Mosque",
      "NGO",
      "CBO",
      "Community Group",
      "Youth Group",
      "Charity Organization",
    ],
  },
  {
    category: "Travel & Tourism",
    subCategory: [
      "Travel Agency",
      "Tours & Safaris",
      "Car Hire",
      "Travel Insurance",
      "Hotel Booking Services",
      "Visa Application Support",
    ],
  },
  {
    category: "Sports & Recreation",
    subCategory: [
      "Sports Shop",
      "Football Academy",
      "Swimming Pool",
      "Gaming Lounge",
      "Outdoor & Camping Gear",
      "Club & Recreation Center",
    ],
  },
];
